<script>
export default {
	props: {
		value: Object,
		selected: Boolean,
	},
	data() {
		return {
			// clarin365dni: this.value.clarin365dni,
			clarin365card: this.value.clarin365card,
		}
	},
	watch: {
		// clarin365dni() {
		// 	this.$emit('input', { clarin365dni: this.clarin365dni, clarin365card: this.clarin365card })
		// },
		clarin365card() {
			this.$emit('input', {
				// clarin365dni: this.clarin365dni,
				clarin365card: this.clarin365card,
			})
		},
	},
}
</script>

<template>
	<div>
		<div>
			<b>Clarin 365</b>
			<div>Ingresa los datos de tu tarjeta Clarin 365</div>
			<small>No acumulable con otras promociones</small>
		</div>
		<div v-if="selected" class="pt-4">
			<!-- <div class="pb-4">
				<TextField
					v-model="clarin365dni"
					label="DNI"
					placeholder="Ingresa el DNI del titular de la tarjeta"
					dense
				/>
			</div> -->
			<div>
				<TextField
					v-model="clarin365card"
					label="Número de Tarjeta"
					placeholder="Ingresa el número impreso en tu tarjeta"
					dense
				/>
			</div>
		</div>
	</div>
</template>

